import { EXECUTION, IDEA, IMPLEMENTATION, PREPARATION, STOPPED } from '@/model/innovation-project/states'

export default {
    blocks: {
        title: 'Title',
        description: 'Project description',
        image: 'Picture',
        participants: 'Project team',
        state: 'Project state',
        links: 'Links to'
    },

    labels: {
        description: 'Short description',
        environment: 'Environment',
        innovationFields: 'Innovations fields',
        macrotrends: 'Macro-Trends',
        trendradars: 'Trend radars',
        objective: 'Project details',
        state: 'State',
        title: 'Title'
    },

    states: {
        [EXECUTION]: 'Excecution',
        [IDEA]: 'Idea',
        [IMPLEMENTATION]: 'Finished',
        [PREPARATION]: 'Preparation',
        [STOPPED]: 'Stopped'
    },

    empty: {
        participants: 'Unfortunately no users could be found',
        macrotrends: 'Unfortunately no macro-trends could be found',
        trendradars: 'Unfortunately no trend radars could be found',
        innovationFields: 'Unfortunately no innovation fields could be found'
    },

    descriptions: {
        description:
      'What is the innovation project about? Who is the target group? What should be created ' +
      'at the end of the project (e.g. a product, service, know-how or process)?',
        environment:
      'What is the market environment like? Which trends and market changes affect the innovation ' +
      'project? Are there competitors or similar solutions in the market?',
        objective:
      'How do you describe the concrete solution? What are milestones of the project? Who is involved ' +
      'in the project (e.g. business units, external service providers)?',
        participants:
      'Who is involved in the realisation of the innovation project. Note: The selected users receive ' +
      'administrative rights for the innovation project and can also edit it.'
    },

    tooltip: {
        state:
      'The innovation project is only visible to the users of the Trendmanager when the status is ' +
      '"published". The selected users of the project team can already see and edit the innovation ' +
      'project in "draft" status.'
    },

    buttons: {
        reset: 'Cancel',
        submit: 'Save'
    },

    validation: {
        title: {
            required: 'Please enter a title',
            maxLength: 'The title must not contain more than 100 characters'
        },
        description: {
            required: 'Please enter a description'
        },
        image: {
            size: 'The image must not be larger than 8MB',
            mimetype: 'Please only use GIF/JPG/PNG'
        }
    }
}
